module.exports = __webpack_public_path__ + "img/dashboard-landing-wetness-status.d1e7d02e.svg";